import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'

class EditButton extends Component {
    handleClick = () => {
        const { basePath, record } = this.props
        this.props.push(`${basePath}/${record.id}`)
    }

    render() {
        return (
            <IconButton color="primary" onClick={this.handleClick}>
                <EditIcon />
            </IconButton>
        )
    }
}

export default connect(null, { push })(EditButton)
